export enum JobType {
  Orchestration = 'ORCHESTRATION',
  Transformation = 'TRANSFORMATION'
}
